import axios from 'axios'

import {
  baseAPIPath,
  authRequestInterceptors,
  authResponseSuccessInterceptors,
  authResponseErrorInterceptors
} from './configVariables'

// const instance = axios.create({
//   baseURL: `${baseAPIPath}/dashboard_performance_comparison/chart?appraisal_type_code=APT10&form_id=1&org_id=120&company_id=1`,
// });

const instance = axios.create({
  baseURL: `${baseAPIPath}/dashboard_performance_comparison`
})

instance.interceptors.request.use(authRequestInterceptors)
instance.interceptors.response.use(authResponseSuccessInterceptors, authResponseErrorInterceptors)

export default instance
